import React from "react";
import PropTypes from "prop-types";

// Anonymous visitors get the whole tool, so the only thing to sell is keeping
// their progress - which is true, immediate, and needs no Pro pitch. Said early
// and quietly as a bar, then once more with feeling when a round ends.
//
// Deliberately never blocks the page: this wants to survive being posted in a
// language subreddit, and an upsell above the fold is what gets those removed.
export default function SignUpPrompt({ onDismiss, signInUrl, signUpUrl, variant }) {
  const links = (
    <>
      <a className="btn btn-success btn-xs" href={signUpUrl}>
        Sign up free
      </a>
      {" "}
      <a className="gna-signup-login" href={signInUrl}>
        or log in
      </a>
    </>
  );

  if (variant === "card") {
    return (
      <div className="gna-signup-card">
        <p className="gna-signup-card-lead">Keep this progress</p>
        <p>
          Your known words are saved in this browser only. Sign up free to save them
          to your account and pick up on any device.
        </p>
        {links}
      </div>
    );
  }

  return (
    <div className="gna-signup-bar">
      {/* One flowing sentence rather than separate flex items: at phone width
          the pieces wrap where the text wants to break, not into a ragged
          column of boxes. */}
      <p className="gna-signup-text">
        Progress saves in this browser only.{" "}
        {links} to save it to your account.
      </p>
      {onDismiss && (
        <button
          aria-label="Dismiss"
          className="gna-signup-dismiss"
          onClick={onDismiss}
          type="button"
        >
          &times;
        </button>
      )}
    </div>
  );
}

SignUpPrompt.defaultProps = { onDismiss: null, variant: "bar" };

SignUpPrompt.propTypes = {
  onDismiss: PropTypes.func,
  signInUrl: PropTypes.string.isRequired,
  signUpUrl: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(["bar", "card"]),
};
